import { createContext } from 'react';
import { Student } from '../types';

const StudentContext = createContext<Student | undefined>(undefined);

export default StudentContext;
